export default __webpack_public_path__ + "static/media/arrow-right-white.9e65621a.svg";